
const PHONE = {
  TEL: "tel:2483852881",
  DISPLAY: "(248) 385‑2881",
}

const ICONS = {
  FACEBOOK: "https://www.facebook.com/cleanfixservicesllc",
  TWITTER: "https://x.com/CleanFixService",
  INSTAGRAM: "https://www.instagram.com/cleanfixservices1/",
  NEXTDOOR: "https://nextdoor.com/pages/cleanfix-services-llc-farmington-hills-mi",
}

export { ICONS, PHONE }